import React, { useState, useEffect, useRef } from 'react'
import { useQuery } from '@apollo/client';
import * as d3 from 'd3';
import thecsvdata from './streamgraph.csv';
import './pop.css';

const Steamgraph = (props) => {

    const parentgraph = useRef(null);
    const d3Container = useRef(null);
    const [theWidth, setTheWidth] = useState(0);

    var sectorWidth,leftBegin,rightBegin,xScale,xAxisRight,xAxisLeft,pyramid,legend,leftBarGroup,rightBarGroup;
    
    var style = {
        leftBarColor: '#6c9dc6',
        rightBarColor: '#de5454',
        tooltipBG: '#fefefe',
        tooltipColor: 'black'
    };

    const translation = (x, y) => {
        return 'translate(' + x + ',' + y + ')';
    }

    const prettyFormat = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    const colorTransform = (c1, c2) => {
        var c1 = c1.replace('#',''),
            origHex = {
                r: c1.substring(0, 2),
                g: c1.substring(2, 4),
                b: c1.substring(4, 6)
            },
            transVec = {
                r: c2.substring(0, 2),
                g: c2.substring(2, 4),
                b: c2.substring(4, 6)
            },
            newHex = {};

        function transform(d, e) {
            var f = parseInt(d, 16) + parseInt(e, 16);
            if (f > 255) {
                f = 255;
            }
            return f.toString(16);
        }
        newHex.r = transform(origHex.r, transVec.r);
        newHex.g = transform(origHex.g, transVec.g);
        newHex.b = transform(origHex.b, transVec.b);
        return '#' + newHex.r + newHex.g + newHex.b;
    }

    var margin = {
        top: 50,
        right: 20,
        bottom: 50,
        left: 20,
        middle: 20
    };
    
    

    useEffect(
        () => {
            
            if (thecsvdata !== null && parentgraph) {
                setTimeout(function(){
                d3.csv(thecsvdata).then(csvdata => {
                    //do what you need here
                

                    var width = parentgraph.current.offsetWidth;
                    var height = 500;
                    var shapemargin = 40;
                    // console.log(parentgraph.current.offsetWidth);
                    const radius = Math.min(width, height) / 2 - shapemargin;
                    const bradius = Math.min(width, height) / 2 - shapemargin * 0.3;
                
                    var arcGenerator = d3.arc().innerRadius(bradius).outerRadius(bradius)
                    var piedata = {};    

                    var tooltipDiv = d3.select("body").append("div")
                    .attr("class", "tooltip")
                    .style("opacity", 0);
                    
                    var styleSection = d3.select(parentgraph.current).append('style')
                    .text('svg {max-width:100%} \
                    .tooltip {position: absolute;line-height: 1.1em;padding: 7px; margin: 3px;background: ' + style.tooltipBG + '; color: ' + style.tooltipColor + '; pointer-events: none;border-radius: 6px;}')


                    window.addEventListener("resize", handleResize);
                    handleResize();
                    function handleResize() {
                        try {
                            document.getElementById("steamgraph").remove();
                        } catch {
                            // do nothing
                        }
                        
                        setTheWidth(parentgraph.current.getBoundingClientRect().width);

                            //const color = d3.scaleOrdinal(d3.schemeSet3);  
                            
                            // List of groups = header of the csv files
                            var keys = csvdata.columns.slice(1);
                            //var years = csvdata.rows.slice(1);
                            var years = csvdata.map(arow => arow.year);

                            var svg;
                            if (theWidth > 0) {
                                svg = d3.select(parentgraph.current)
                                .attr("id","steamgraph")
                                .attr("width", theWidth)
                                .attr("height", (height - margin.top + margin.bottom))
                                .append("g")
                                .attr("transform", `translate(${theWidth/2}, ${height/2})`);  
                            } else {
                                svg = d3.select(parentgraph.current) 
                                .append("svg")
                                .attr("id","steamgraph")
                                .attr("width", parentgraph.current.getBoundingClientRect().width)
                                .attr("height", (height - margin.top + margin.bottom))
                            }

                            // Add X axis
                            var x = d3.scaleLinear()
                                .domain(d3.extent(csvdata, function(d) { return d.year; }))
                                .range([ margin.left, parentgraph.current.getBoundingClientRect().width - 20]);

                            // Add X axis label:
                            svg.append("text")
                                .attr("text-anchor", "middle")
                                .attr("x", (parentgraph.current.getBoundingClientRect().width) / 2)
                                .attr("y", height-30 )
                                .text("Time (election years)");

                            // Add Y axis
                            var y = d3.scaleLinear()
                                .domain([-300, 300])
                                .range([ height, 0 ]);

                            // color palette
                            var color = d3.scaleOrdinal()
                                .domain(keys)
                                .range(['#e55453','#321fdb','#0BA6F4','#62BC43','#fab116','#E79518','#29D648','#C8DF20','green','#339aff','#2eb85c','orange','#9F9F60']);

                            //stack the data?
                            var stackedData = d3.stack()
                                .offset(d3.stackOffsetSilhouette)
                                .keys(keys)
                                (csvdata)

                            // create a tooltip
                            var Tooltip = svg
                                .append("text")
                                .attr("x", 0)
                                .attr("y", 0)
                                .style("opacity", 0)
                                .style("font-size", 17)

                            // Three function that change the tooltip when user hover / move / leave a cell
                            var mouseover = function(event, d) {
                                Tooltip.style("opacity", 1)
                                d3.selectAll(".myArea").style("opacity", .2)
                                d3.select(this)
                                .style("stroke", "black")
                                .style("opacity", 1);
                                tooltipDiv.transition()
                                .duration(200)
                                .style("opacity", 0.9);
                                tooltipDiv.html("<strong>"+d.key+"</strong>")
                                .style("left", (event.pageX) + "px")
                                .style("top", (event.pageY - 28) + "px");

                            }
                            var mouseleave = function(d) {
                                Tooltip.style("opacity", 0)
                                d3.selectAll(".myArea").style("opacity", 1).style("stroke", "none");
                                tooltipDiv.transition()
                                .duration(500)
                                .style("opacity", 0);                                
                            }

                            // Area generator
                            var area = d3.area()
                                .x(function(d) { return x(d.data.year); })
                                .y0(function(d) { return y(d[0]); })
                                .y1(function(d) { return y(d[1]); })
                                .curve(d3.curveBundle.beta(1));

                            // Show the areas
                            svg
                                .selectAll("mylayers")
                                .data(stackedData)
                                .enter()
                                .append("path")
                                .attr("class", "myArea")
                                .style("fill", function(d) { return color(d.key); })
                                .attr("d", area)
                                .on("mouseover", mouseover)
                                .on("mouseleave", mouseleave)

                            svg.append("g")
                            .attr("transform", "translate(0," + height*0.8 + ")")
                            .call(d3.axisBottom(x).tickSize(-height*.7).tickValues(years).tickFormat(d3.format(".000f")))
                            .selectAll('text')
                            .style('align', 'left')
                            .style("font-size", "6px")
                            .style('text-anchor','start')
                            .style('transform', 'rotate(90deg) translate(7px, -5px)')
                            .select(".domain").remove()
                            // Customization
                            svg.selectAll(".tick line").attr("stroke", "#b8b8b8").attr("opacity","0.2")

                            }
                                
                                return () => window.removeEventListener("resize", handleResize);
                
                        });
                        }, 200);
                    }                    
                
        },[parentgraph, d3Container])

    return (
        <div ref={parentgraph} style={{width:'auto', display: 'flex', flexDirection: 'column'}}>
        </div>
    )
  }
  
  export default Steamgraph;